import { principles } from "@/mocks/guaData";

export default function Philosophy() {
  return (
    <section id="philosophy" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5 lg:gap-14">
          <div className="lg:col-span-2">
            <p className="flex items-center gap-2 text-sm font-semibold text-primary-600">
              <span className="flex h-5 w-5 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-heart-line text-[13px]"></i>
              </span>
              我们的吃瓜态度
            </p>
            <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">热闹归热闹，底线不能丢</h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
              做榜单是一件“看着简单、其实得端着”的事。热度数字背后是一个个真实发生的公共话题，也可能牵涉真实的人。
              所以我们给自己的规矩是：热度可以追，事实必须先核实；讨论可以热烈，但绝不把矛头指向对个体的攻击。
            </p>
            <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">
              我们是一支关注中文互联网热点的小团队，靠公开信源做交叉核实，靠读者反馈不断校准。希望你在这里追更轻松，
              也能更理性——这才是“吃瓜”最舒服的状态。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <a
                href="#rank"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-up-line text-[14px]"></i>
                </span>
                回到今日热榜
              </a>
              <a
                href="#faq"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
              >
                看看常见问题
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-3">
            {principles.map((p) => (
              <article
                key={p.title}
                className="group rounded-lg border border-background-200 bg-background-100/70 p-6 transition-colors hover:border-primary-200"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{p.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}